// `#` is the digit placeholder used by react-number-format's PatternFormat
export const VERIFICATION_SMS_MASK = '# # #  # # #';
export const VERIFICATION_CODE_MASK = '# # #  # # #';
